<template>
  <div class="container-fluid position-relative p-0">
    <!-- Narbar -->
    <the-navbar />

    <!-- Hero-header -->
    <div v-if="slider === false" class="container-fluid bg-primary hero-header">
      <div class="container-xl py-3 py-lg-0" style="margin-top: 5rem">
        <div class="row align-items-center">
          <slot></slot>
        </div>
      </div>
    </div>
    <div class="bg-primary hero-header pt-lg-6 pt-0" v-if="slider === true">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import TheNavbar from "./TheNavbar.vue";
export default {
  props: {
    slider: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TheNavbar,
  },
};
</script>
<style scoped>
.hero-header-img {
  background-color: #080e49 !important;
}
.hero-header {
  background-color: #080e49 !important;
  padding: 6rem 0 0rem 0;
  margin-bottom: 3rem;
}
</style>
